import React from 'react';
import { ProductsListItem } from './ProductsListItem';
export const ProductsList = ({ children }) => {
    return React.createElement("ul", null, children);
};
ProductsList.Item = ProductsListItem;
